import safeAwait from '../../../../lib/safeAwait'
import errorHelper, { httpHandler } from '../../../../lib/errorHelper'

const fetchBatch = async (actions, params) => {
  const [error, payload] = await safeAwait(
    actions.fetchBatchProposal(params).then(httpHandler)
  )
  const errorMessage = errorHelper.parseErrorMessage(error)
  if (errorMessage) {
    return [{ message: errorMessage, params }]
  }

  return [undefined, payload]
}

export default fetchBatch
